import { Component, Input } from '@angular/core';
import { GridFilterBase } from '../grid-filter-base/grid-filter-base';

@Component({
    selector: 'spv2-grid-jurisdiction-obligation-filter',
    templateUrl: './grid-jurisdiction-obligation-filter.component.html',
    styleUrls: ['./grid-jurisdiction-obligation-filter.component.scss'],
    standalone: false
})
export class GridJurisdictionObligationFilterComponent extends GridFilterBase<string> {
  @Input() smallView = false;
}
